<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZGgK3p/tc-custom/FC-9781528964173.jpg?1684514926481?1709061882698" alt="This image is the cover for the book A Small Creation of Literature"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Small Creation of Literature
      </h1>
      <p class="bookDescription body article font2">
        <p>If you ever wanted to read something different and lift you up out of your seat, then here it is. Get ready to be inspired, intrigued and captivated by this emotional ride that will leave you speechless. A variety of creative literature for all ages to enjoy from short stories, poems, theatre play and a radio play, all in one. To accompany this, there is a biography, a sensitive and painful journey; a simple story about first love, this captures the ’80s in all its glory. ‘For the Love of Cricket’ will have all cricket fans bowled over, ‘The Last Leaf’ is a magical story which will leave children feeling refreshed, ‘A Bunch of Flowers’ narrates a mother’s unconditional love for her sons. ‘Passing of Time’ is a beautiful poem on life itself. ‘Arranged Marriage’ is really good and the sense of humour is exhilarating; ‘The Successor’, a radio play with a twist, is tension all the way. For a much more dark and deep read, there is ‘The Room’, a theatre play; and ‘Answering Back’, a short story which many of you will relate to. This collection has everything, laughter, sadness, hurt and pain, topping it all up with sheer delight.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kulvinder Kherteru
      </h2>
      
      <p class="authorDescription body article">Kulvinder Kherteru is a devoted daughter-in-law, a wife and a mother. She has always had a passion for reading books since childhood. In her late 40s, she obtained her GCSE in English within six months and completed her BA Honour’s degree over the period of eight years. She has been working in Special Needs Education for 19 years to date and continues to do so.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57d00f6b